import styled from 'styled-components'
import { Icon } from '../icon/icon'
import { StyledTitleText } from './styledQuickLinksCard'

export const StyledAccordion = styled.a`
  text-decoration: none;
  color: #d83b00;
`

export const StyledAccordionDetails = styled.div`
  padding-left: ${props => props.theme.typography.pxToRem(4)};
  padding-right: ${props => props.theme.typography.pxToRem(4)};
`

export const StyledChevron = styled(Icon)`
  position: absolute;
  right: ${props => props.theme.typography.pxToRem(0)};
  top: 24px;
  font-size: ${props => props.theme.typography.pxToRem(17)};
  transition: 0.2s linear;
`

export const StyledAccordionSummary = styled.div`
  padding-left: 0;
  padding-right: 0;
  padding-top: ${props => props.theme.typography.pxToRem(16)};
  padding-bottom: ${props => props.theme.typography.pxToRem(16)};
  position: relative;

    img {
        filter: grayscale(1);
    }

  &:hover {
    ${StyledTitleText} {
      color: ${props => props.theme.palette.secondary.dark};
    }
    ${StyledChevron} {
      right: ${props => props.theme.typography.pxToRem(-10)};
    }
  }
`